import { useEffect } from 'react';
import { useNotificationStore } from '../store/notificationStore';
import { setBadge } from '../lib/badging';

/**
 * Pushes the critical counter (unread notifications) to the dock icon through the
 * Badging API. The notification store already keeps it current (Supabase realtime),
 * so this hook only observes and forwards. Actions to validate no longer count: the
 * Actions queue was retired on 06/10/2026 (PLAN-GENERICITE phase 1).
 *
 * Mount it ONCE in the tree (typically in AdminLayout).
 */
export function useBadge(): void {
  const unreadNotifs = useNotificationStore((s) => s.unreadCount);

  useEffect(() => {
    void setBadge(unreadNotifs);
  }, [unreadNotifs]);

  // On unmount (logout, closing) the badge is cleared — otherwise it outlives the session.
  useEffect(() => {
    return () => {
      void setBadge(0);
    };
  }, []);
}
